<template>
  <div>
    <v-snackbar :visible="snackbarVisible" :message="snackbarMessage" :error="snackbarError" @close="hideSnackbar">
      {{ snackbarMessage }}
      <v-btn color="red" text @click="hideSnackbar">Close</v-btn>
    </v-snackbar>

    <div v-if="visible" :class="['snackbar', error ? 'red_error' : '']">
      <span class="snackbar_text">
        <v-icon :class="iconClass" :color="iconColor" />
      </span>
      <span :class="{ 'snackbar_text_massage': message.length > 10 }" class="ml-2">{{ message }}</span>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';


export default {
  props: {
    message: {
      type: String,
      required: true
    },
    visible: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    iconClass() {
      return this.error ? 'mdi mdi-alert-circle-outline' : 'mdi mdi-check-circle-outline';
    },
    iconColor() {
      return this.error ? '#FF0000' : '#006CEA';
    },
    ...mapState({
      snackbarVisible: state => state.snackbar.visible,
      snackbarMessage: state => state.snackbar.message,
      snackbarError: state => state.snackbar.error
    }),
  },
  methods: {
    ...mapActions(['hideSnackbar'])
  }

};
</script>

<style>
.snackbar {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 300px;
  height: auto;
  border-top: 3px solid #006CEA;
  background: #fff;
  display: flex;
  align-items: center;
  box-shadow: 0px 0px 6px #c3c3c3;
  animation-duration: 1s;
  animation-name: slidein;
  animation: slidein 0.8s forwards, hold 5s forwards 5s, slideout 1s forwards 6s;
}

@keyframes slidein {
  from {
    right: -350px;
  }

  to {
    right: 20px;
  }
}

@keyframes hold {
  from {
    right: 20px;
  }
  to {
    right: 20px;
  }
}

@keyframes slideout {
  from {
    right: 20px;
  }
  to {
    right: -350px;
  }
}


.snackbar_text {
  flex: 1;
  padding-left: 16px;
}

.snackbar_text_massage { width: 250px;word-break: break-all;font-size: 12px;padding: 12px;padding-left: 0px;padding-right: 12px; }

.snackbar.red_error {
  border-top: 3px solid #F24545;
}
</style>